import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * 페이지를 옮길 때 스크롤을 맨 위로 되돌린다.
 *
 * 리액트 라우터는 화면을 새로 불러오지 않고 안의 내용만 갈아끼우기 때문에,
 * 브라우저가 스크롤을 0으로 돌려 주지 않아 직전 페이지에서 내려간 만큼
 * 그대로 내려간 채로 다음 페이지가 열린다.
 *
 * 뒤로·앞으로 가기(POP)는 보던 자리로 돌아가는 편이 자연스러워 건드리지 않는다.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  // 화면에 그려지기 전에 옮겨야 아래쪽이 잠깐 비쳤다 올라가는 일이 없다.
  useLayoutEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
